import React from "react";

export const HistorialCompras = ({ compras = [] }) => {
  return (
    <div className="font-family-montserrat container-historial-compras">
      <h1 className="extrabold-800 color-520FDA font20 pad-18 txt-center">
        HISTORIAL DE COMPRAS
      </h1>

      <div className="container-cards">
        {compras.length === 0 ? (
          <div>No hay compras en el histórico</div>
        ) : (
          compras.map((item, idx) => (
            <div key={idx} className="container-card-info flex-container">
              <div className="producto-compra flex-container txt-center">
                <img
                    src={item.productoImgUrlPrincipal}
                    alt={item.productoNombre}
                    className="img-carro-compras"
                />
              </div>

              <div className="info-carro-compras">
                <div className="font13 txt-semibold item-descripcion">
                    {item.productoNombre}
                </div>
                <div className="color-A4A4A4 font7 txt-semibold">
                    {item.productoSku}
                </div>

                <div className="precio-info">
                    <div className="color-520FDA txt-semibold precio-actual">
                    S/. {item.productoPrecio.toFixed(2)}
                    </div>
                </div>
              </div>
            </div>
          ))
        )}

      </div>
    </div>
  )
}